import { FC } from 'react';

type Props = {
	className?: string;
};

const InvoiceIcon: FC<Props> = ({ className }) => {
	return (
		<svg
			width='20'
			height='20'
			viewBox='0 0 20 20'
			xmlns='http://www.w3.org/2000/svg'
			fill='none'
			stroke='#EAEAEA'
			className={className}>
			<path
				d='M3.60156 15.3168V6.84346C3.60156 4.56023 3.60156 3.41861 4.30451 2.70931C5.00746 2 6.13884 2 8.40161 2H11.6016C13.8644 2 14.9958 2 15.6987 2.70931C16.4017 3.41861 16.4017 4.56023 16.4017 6.84346V15.3168C16.4017 16.5261 16.4017 17.1308 16.0321 17.3688C15.4282 17.7578 14.4946 16.9421 14.0249 16.646C13.6369 16.4013 13.443 16.2789 13.2277 16.2719C12.995 16.2642 12.7976 16.3816 12.3784 16.646L10.8496 17.6101C10.4372 17.8701 10.2311 18.0002 10.0016 18.0002C9.77219 18.0002 9.56602 17.8701 9.15362 17.6101L7.62491 16.646C7.23692 16.4013 7.04293 16.2789 6.82762 16.2719C6.59497 16.2642 6.39753 16.3816 5.97828 16.646C5.50874 16.9421 4.57507 17.7578 3.97113 17.3688C3.60156 17.1308 3.60156 16.5261 3.60156 15.3168Z'
				stroke='inherit'
				strokeWidth='1.25'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M9.20081 9.2002H6.80078'
				stroke='inherit'
				strokeWidth='1.25'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M11.6008 6H6.80078'
				stroke='inherit'
				strokeWidth='1.25'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
};

export default InvoiceIcon;
